export interface TwoFactorStatus {
  enabled: boolean;
}

export interface TotpSetupResponse {
  otpauth_uri: string;
  secret: string;
}

export interface TotpConfirmResponse {
  ok: boolean;
  recovery_codes: string[];
}

export interface LoginTotpRequest {
  challenge_token: string;
  code: string;
}

export interface TwoFactorChallengeResponse {
  challenge_token: string;
  two_factor_required: true;
}

export function isTwoFactorChallenge(
  value: unknown,
): value is TwoFactorChallengeResponse {
  if (typeof value !== "object" || value === null) return false;
  const record = value as Record<string, unknown>;
  return record.two_factor_required === true && typeof record.challenge_token === "string";
}
